<template lang="html">
  <el-tabs
    type="border-card"
    class="order-wrapper"
    v-model="ruleForm.activeName"
    @tab-click="handleClick"
  >
    <el-tab-pane
      v-for="(item, index) in tabsArr"
      :label="item.label"
      :name="index.toString()"
      :lazy="true"
      :key="index"
      v-if="(!isNewOrder && index === 0) || isNewOrder"
    >
      <div class="table-wrapper" v-loading="tableLoading">
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          class="table-wrapper-table"
        >
          <el-table-column fixed="left"  align="center" prop="status" label="操作">
            <template slot-scope="scope">
              <span class="link-url" @click="goDetail(scope.row)">详情</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="status" label="状态">
            <template slot-scope="scope">
              {{ scope.row.status | statusFormat }}
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            prop="orderNo"
            label="订单号"
            width="220"
          >
          </el-table-column>
          <el-table-column align="center" prop="name" label="货物">
            <template slot-scope="scope">
              {{ scope.row.goodsName[0] }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="totalMoney"
            label="运费"
            width="100"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="totalWeight"
            label="吨位"
            width="100"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间"
            width="160"
          >
            <template slot-scope="scope">
              {{ scope.row.createTime | timeFormat }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="deliverTime"
            label="预提时间"
            width="160"
          >
            <template slot-scope="scope">
              {{ scope.row.deliverTime | timeFormat }}
            </template>
          </el-table-column>
          <el-table-column
                  align="center"
                  prop="completeTime"
                  label="确认送达时间"
                  width="160"
          >
            <template slot-scope="scope">
              {{ scope.row.completeTime | timeFormat }}
            </template>
          </el-table-column>
          <el-table-column
                  align="center"
                  prop="plateNo"
                  label="车号"
                  width="160"
          >
            <template slot-scope="scope">
              {{ scope.row.truck ? scope.row.truck[0].plateNo : ''}}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="city_from"
            label="起点"
            show-overflow-tooltip
            width="140"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="city_to"
            label="终点"
            show-overflow-tooltip
            width="140"
          >
          </el-table-column>

          <el-table-column align="center" prop="billing" label="是否开票">
            <template slot-scope="scope">
              {{ scope.row.billing === 1 ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="sbustitude"
            label="是否货到付款"
            width="120"
          >
            <template slot-scope="scope">
              {{ scope.row.sbustitude === 1 ? "是" : "否" }}
            </template>
          </el-table-column>
        </el-table>
        <div class="table-page-wrapper">
          <el-pagination
            layout="prev, pager, next"
            :total="total"
            :hide-on-single-page="true"
            @current-change="currentChange"
          >
          </el-pagination>
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import qs from "qs";

export default {
  props: {
    ruleForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tabsArr: [
        {
          label: "全部",
          url: "list"
        },
        {
          label: "待报价",
          url: "wait-list"
        },
        {
          label: "服务中",
          url: "in-service-list"
        },
        {
          label: "已完成",
          url: "list",
          status: 700
        }
      ],
      tableLoading: false,
      tableData: [],
      total: 0,
      page: 1
    };
  },
  computed: {
    isNewOrder() {
      return this.ruleForm.orderType === 1;
    }
  },
  created() {
    this.getDataList();
  },
  methods: {
    handleClick() {
      this.getDataList(true);
    },
    goDetail({ _id }) {
      this.$router.push({
        name: "orderDetail",
        params: { id: _id },
        ...(!this.isNewOrder && { query: { isOld: 1 } })
      });
    },
    async getDataList(type) {
      type && (this.page = 1);
      this.tableLoading = true;
      let { orderType, activeName, ...obj } = this.ruleForm;
      let currentObj = this.tabsArr[activeName];
      let status = currentObj.status;
      let searchData = this.$clearEmptyParams(obj);

      let bool = !!Object.keys(searchData).length;
      let {
        data: { list, count, total }
      } = await this.$http.post(
        `/shipper/order-shipper/${this.isNewOrder ? "" : "former-order-"}${
          currentObj.url
        }`,
        qs.stringify({
          page: this.page,
          ...(status && { status }),
          // 下面这个是临时使用
          // status: 700,
          ...(bool && { searchData: JSON.stringify(searchData) })
        })
      );
      this.tableData = list;
      this.total = count || total;
      this.tableLoading = false;
    },
    currentChange(val) {
      this.page = val;
      this.getDataList();
    }
  },
  watch: {},
  components: {}
};
</script>

<style lang="scss" scoped>
.table-wrapper {
  min-height: calc(100vh - 571px);
  .table-wrapper-table {
    margin-top: 10px;
  }
  .table-page-wrapper {
    padding-top: 14px;
    display: flex;
    flex-direction: row-reverse;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/order/components/orderTable/index.vue